import * as d3 from 'd3';

const previewDXF = (id, parsedData) => {

  var lineSegments = parsedData.lines;
  const gx = parsedData.gx;
  const gy = parsedData.gy;

  var w = 200;
  var h = 200;
  var scale = .5;

  if(gx > gy){
    w = 200;
    h = gy/gx * 200;
  } else if(gy > gx){
    h = 200;
    w = gx/gy * 200;
  }

  var canvas = document.getElementById(id);

  canvas.width = w;
  canvas.height = h;

  // get context and clear it
  var context = canvas.getContext("2d");
  context.setTransform(1, 0, 0, 1, 0, 0);
  context.clearRect(0, 0, w, h);
  
  context.translate(w / 4, h * 3/4);
  context.save();

  context.lineWidth = 1;
  context.strokeStyle = '#999';
  context.setLineDash([5,5]);
  context.rect(0,0,w*scale,-h*scale);
  context.stroke();

  context.setLineDash([]);

  for(var x = -1; x <= 1; x++){
    for(var y = -1; y <= 1; y++){
      context.lineWidth = 1;
      for(var i in lineSegments){
        var l = lineSegments[i];
        // console.log(x,y,l);
        
        if( x === 0 && y === 0){
          if(l.errors.length > 0){
            context.strokeStyle = '#D24128';
          } else {
            context.strokeStyle = '#4FBA62';
          }
        } else {
          context.strokeStyle = '#000';
        }

        context.beginPath();
        context.moveTo(l.x1 * w/gx * scale + x * w * scale, -l.y1 * h/gy * scale + y * -h * scale);
        context.lineTo(l.x2 * w/gx * scale + x * w * scale, -l.y2 * h/gy * scale + y * -h * scale);
        context.stroke();
      }
    }
  }
  
}

export default previewDXF;


// WEBPACK FOOTER //
// ./src/pattern_utilities/previewDXF.js